import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Flex, H1, Button } from '@bigcommerce/big-design';
import Container from './ui/Container';
import { HomeIcon } from '@bigcommerce/big-design-icons';
// import AppContext from './AppContext';

export default function Header({ activeTab, setActiveTab }) {

    const navigate = useNavigate();
    const handleClick = (link) => {
        navigate(link, { replace: true });
    };
    
    return (
        <Box as="header" id="header" backgroundColor="white" marginBottom="large">
            <Container>
                <Flex
                    className="container"
                    justifyContent={{ desktop: 'space-between' }}
                    paddingVertical={{ mobile: 'none', tablet: 'xxLarge' }}
                >
                    <H1 marginBottom='none'>GroundCloud App</H1>
                    <Flex alignItems={'center'}>
                        <Button variant='subtle' iconOnly={<HomeIcon size="xxLarge" title="home" />} onClick={() => handleClick('/')} />
                    </Flex>
                </Flex>
            </Container>
        </Box>
    );
}
